import React, { useState } from 'react';
import i18next from 'i18next';
import { Button } from 'antd';
import PropTypes from 'prop-types';
import { EditIcon } from 'components/common/SVGIcon';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { editTask } from 'redux/applications/actions';
import { HeaderSidebarWrapper } from './styles';
import TaskModal from '../Modal';

const HeaderTaskDetail = ({ record }) => {
  const [visible, setVisibleModal] = useState(false);
  const [initialValue, setInitialValue] = useState();
  const dispatch = useDispatch();

  const toggleModal = () => {
    setVisibleModal(!visible);
  };

  const onOk = (value) => dispatch(editTask({ id: record.id, data: value }));

  React.useEffect(() => {
    record && setInitialValue({ ...record, date: moment(record.date) });
  }, [record]);

  return (
    <>
      <HeaderSidebarWrapper>
        <span className="title-card">{i18next.t('task.detail')}</span>
        <Button
          type="primary"
          shape="circle"
          disabled={!record.id}
          icon=<EditIcon />
          onClick={toggleModal}
        />
      </HeaderSidebarWrapper>
      <TaskModal
        onOk={onOk}
        initialValue={initialValue}
        visible={visible}
        onCancel={toggleModal}
        toggleModal={toggleModal}
      />
    </>
  );
};

HeaderTaskDetail.propTypes = {
  record: PropTypes.object,
};

export default HeaderTaskDetail;
